import { SpinnerIcon } from "../shared/icons"

import { motion } from "framer-motion"

const ChatLoading = () => {
  return (
    <div className="flex items-center justify-center flex-1 w-full text-gray-600">
      <motion.div animate={{ rotate: 360 }} transition={{ duration: 1, repeat: Infinity, ease: "linear" }}>
        <SpinnerIcon width={16} height={16} />
      </motion.div>
    </div>
  )
}

export default ChatLoading
